import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import CollectionLink from "../../utils/generate-collection-link";
import styles from "./styles.m.css";
import { getStoryHeadline } from "../../utils/utils";
import StoryCardVertical from "../../atoms/story-card-vertical";
import CollectionTitleWithCTA from "../../atoms/CollectionTitleWithCTA";

const TweleStoriesCollection = ({
  collection,
  accentColor,
  authorName = true,
  utmURL = "",
  homecollection = false,
  storyLimit,
  withoutcard
}) => {
  const { items } = collection;

  const [isMyVikatanPage, setIsMyVikatanPage] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsMyVikatanPage(window.location.pathname === "/myvikatan");
    }
  }, []);

  const shouldShowTitle = () => {
    return collection.name && !isMyVikatanPage;
  };

  const stories =
    items
      .filter(({ story = {} }) => getStoryHeadline(story) && story.url)
      .slice(0, storyLimit)
      .map(({ story }) => (
        <StoryCardVertical
          className={styles["story-card"]}
          key={story.id}
          story={story}
          authorName={authorName}
          utmURL={utmURL}
          openInNewTab={true}
          withoutcard={true}
          isMyVikatanPage={isMyVikatanPage}
        />
      )) || [];

  if (!stories.length) {
    return null;
  }

  return (
    <div
      className={`container ${styles["collection-wrapper"]} ${
        homecollection ? styles["home-card"] : styles["not-home-card"]
      }`}
    >
      {/* <CollectionLink collection={collection} className={`${styles["title-grid"]}`}>
        <CollectionTitle className={styles.title} title={name} />
        <Icon type="double-arrow" className={styles["double-arrows"]} />
      </CollectionLink> */}

      <div>
        {shouldShowTitle() && (
          <div>
            <CollectionTitleWithCTA
              className={styles.title}
              title={collection.name}
              theme="red"
              arrowdown="arrowdown"
            />
          </div>
        )}
      </div>
      <div className={`${styles["story-container"]} ${isMyVikatanPage ? styles["myvikatan-story-container"] : ""}`}>
        {stories}
      </div>
    </div>
  );
};

TweleStoriesCollection.propTypes = {
  accentColor: PropTypes.string,
  authorName: PropTypes.bool,
  utmURL: PropTypes.string,
  homecollection: PropTypes.string,
  storyLimit: PropTypes.number,
  openInNewTab: PropTypes.bool,
  withoutcard: PropTypes.bool,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(StoryCardVertical.propTypes))
  })
};
TweleStoriesCollection.storyLimit = 12;

export default TweleStoriesCollection;
